import { Typography, styled } from '@mui/material';

export const ButtonTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  userSelect: 'none',
}));
